import { joinURL } from 'ufo'
import type { ProviderGetImage } from '@nuxt/image'
// @ts-ignore
import { createOperationsGenerator } from '#image'

const operationsGenerator = createOperationsGenerator()

export const getImage: ProviderGetImage = (
  src,
  { modifiers = {}, baseURL } = {}
) => {
  if (!baseURL) {
    // also support runtime config
    baseURL = useRuntimeConfig().public.cloudinary
  }

  const operations = operationsGenerator(modifiers)

  const base = src.startsWith('http') ? src : joinURL(baseURL, src)
  return {
    url: joinURL(base, operations ? '?' + operations : ''),
  }
}
